export const classes = {
  tab: 'py-4 px-0 h-full',
};
